/* istanbul ignore file */
export function inTest(): boolean {
  return process.env.JEST_WORKER_ID !== undefined ? true : false;
}
